import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  EstablishmentRequiredDocumentData,
  EstablishmentRequiredDocumentResponse,
} from '@/common/types/establishmentRequiredDocument'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useEstablishmentRequiredDocument: (
  id: string,
) => UseQueryResult<EstablishmentRequiredDocumentData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentRequiredDocumentResponse, unknown, EstablishmentRequiredDocumentData>({
    queryKey: ['establishmentRequiredDocument', id],
    queryFn: () => privateAxios.get(`/maintenance/establishment_required_documents/${id}`),
    select: (data) => data?.data?.data,
  })
}
